module.exports = __webpack_public_path__ + "static/img/shigongrizhi.703f71f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shigongrizhi.png
// module id = 4FY2
// module chunks = 1